import { render } from "./MainBanner.vue?vue&type=template&id=b123da46&scoped=true"
import script from "./MainBanner.vue?vue&type=script&lang=js"
export * from "./MainBanner.vue?vue&type=script&lang=js"

import "./MainBanner.vue?vue&type=style&index=0&id=b123da46&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b123da46"]])

export default __exports__